import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Tabs, Text } from '@mantine/core';
import { IconAdjustments, IconTruckDelivery } from '@tabler/icons-react';
import { VariablesPostventaCV } from './tabs/variablesPostventaCV';
import { IncotermsPostventaCV } from './tabs/incotermsPostventaCV';

/** Encabezado y pestañas de la configuración postventa; cada pestaña tiene su propio controlador. */
export const ConfiguracionPostventaCV: React.FC = () => {
    const [pestanaActiva, setPestanaActiva] = useState<string | null>('variables');

    // Una sola fila en edición: al cambiar de pestaña se cancela la actual.
    const canceladoresRef = useRef<Record<string, () => void>>({});
    const registrarCancelacion = useCallback((clave: string, cancelar: () => void) => {
        canceladoresRef.current[clave] = cancelar;
    }, []);
    const cancelarTodasLasEdiciones = useCallback(() => {
        Object.values(canceladoresRef.current).forEach(cancelar => cancelar());
    }, []);
    useEffect(() => () => cancelarTodasLasEdiciones(), [cancelarTodasLasEdiciones]);

    return (
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box
                pb="md"
                pt="md"
                style={{
                    flexShrink: 0,
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    backgroundColor: 'var(--mantine-color-body)',
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }}
            >
                <Text fw={700} size="lg">Configuración</Text>
                <Text c="dimmed" size="xs">Parámetros Cotizador Postventa (MOD QR y SEB)</Text>
            </Box>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '0 20px 20px 20px' }}>
                <Tabs
                    value={pestanaActiva}
                    onChange={(valor) => { setPestanaActiva(valor); cancelarTodasLasEdiciones(); }}
                    style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
                >
                    <Tabs.List mb="md">
                        <Tabs.Tab value="variables" leftSection={<IconAdjustments size={14} />}>Valores por Defecto</Tabs.Tab>
                        <Tabs.Tab value="incoterms" leftSection={<IconTruckDelivery size={14} />}>Incoterms</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel value="variables" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                        {pestanaActiva === 'variables' && <VariablesPostventaCV />}
                    </Tabs.Panel>
                    <Tabs.Panel value="incoterms" style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                        {pestanaActiva === 'incoterms' && (
                            <IncotermsPostventaCV onRegistrarCancelacion={registrarCancelacion} onIniciarEdicionGeneral={cancelarTodasLasEdiciones} />
                        )}
                    </Tabs.Panel>
                </Tabs>
            </div>
        </div>
    );
};
